import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { useNavigate } from "react-router-dom";

export const BlogHeader = () => {
    const navigate = useNavigate();
    const bookColloquio = (e) => {
        e.preventDefault();
        navigate("/");
        setTimeout(() => scrollToId("#contatti"), 350);
    };
    return (
        <header className="sticky top-0 z-50 backdrop-blur-xl bg-cream/85 border-b border-ink/10">
            <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 sm:px-12 lg:px-20 py-4" aria-label="Navigazione blog">
                <Link to="/" data-testid="blog-back-home" className="inline-flex items-center gap-2 text-sm font-semibold text-petrol hover:text-petrol-soft transition-colors duration-300">
                    <ArrowLeft size={16} />
                    <span className="leading-tight">
                        <span className="block font-serif text-lg font-semibold text-ink">Dott. Giovanni De Lorenzo</span>
                        <span className="block text-[11px] uppercase tracking-[0.2em] text-sage font-medium">Psicologo · Psicoterapeuta</span>
                    </span>
                </Link>
                <button
                    data-testid="blog-book-btn"
                    onClick={bookColloquio}
                    className="inline-flex items-center rounded-full bg-petrol text-cream px-6 py-2.5 text-sm font-semibold hover:bg-petrol-soft hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
                >
                    Prenota un colloquio
                </button>
            </nav>
        </header>
    );
};
